import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { selectConfig } from '../../modules/config/config.selector';
import { ApplicationsState } from '../../modules/applications/applications.state';
import { selectUrlParams } from '../../modules/url-params/url-params.selector';
import { LoggerService } from './logger.service';

/**
 * REST Client to retrieve application logo.
 *
 * see https://int0csasdevelopportal.docs.apiary.io/#reference/aplikace/zisakni-logo-pro-applikaci/ziskani-logo-aplikace
 */
@Injectable()
export class LogoService {

    ssfUrl: string;

    accessToken: string;
    webApiKey: string;

    private headers(): HttpHeaders {
        return new HttpHeaders()
            .set('Authorization', 'Bearer' + ' ' + this.accessToken)
            .append('WEB-API-Key', this.webApiKey)
            .append('Cache-Control', 'max-age=3600');
    }

    constructor(private http: HttpClient, private store: Store<ApplicationsState>, private loggerService: LoggerService) {
        this.store.select(selectConfig).subscribe(config => {
            this.ssfUrl = config ? config.apiUrl.ssf : null;
            this.webApiKey = config ? config.webApiKey : null;
        });

        this.store.select(selectUrlParams).subscribe(urlParams => {
            this.accessToken = urlParams ? urlParams.access_token : null;
        });
    }

    /**
     * Returns application image as blob.
     *
     * Empty if the backend errors.
     *
     * https://int0csaspsd2selfservice.docs.apiary.io/#reference/logo/logo-app/nastaveni-globalniho-souhlasu
     */
    public loadApplicationImage(appId: string): Observable<Blob> {
        return this.loadImage(this.ssfUrl + `/logo/app/${appId}`);
    }

    private loadImage(url): Observable<Blob> {
        return this.http.get(
            url,
            {
                headers: this.headers(),
                responseType: 'blob'
            })
            .catch(err => {
                this.loggerService.warn(err);
                return Observable.empty<Blob>();
            });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/services/logo.service.ts